import angular from 'angular'
var GJV = require('geojson-validation')

let isNumericArray = angular.module('isNumericArray', []).
  directive('isNumericArray', function ($parse, $compile, GeojsonBuilder) {
    'ngInject'
    return {
      require: 'ngModel',
      link: function (scope, elem, attrs, ctrl) {

        let active = $parse(elem.attr('is-numeric-array'))(scope)

        if (active) {
          scope.$watch(attrs.ngModel, function (value) {
            if (!_.isNil(value)) {
              let validGeojson = false
              try {
                let geojsonArray = JSON.parse(value);


                validGeojson = GJV.valid(GeojsonBuilder.getGeojson(geojsonArray));
              } catch (e) {
                console.log('invalid geojson format')
              }
              console.log('geojson validity: '+validGeojson)
              ctrl.$setValidity('numeric-array', validGeojson)
            }
          })
        }
      },
    }
  }).name

export default isNumericArray





// WEBPACK FOOTER //
// ./client/app/common/directive/isNumericArray/isNumericArray.js